import { openBlock as e, createElementBlock as l, createElementVNode as c } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, o = /* @__PURE__ */ c("path", {
  "fill-rule": "evenodd",
  d: "M7.715.708a1.44 1.44 0 0 1 .57 0c.219.045.413.154.557.235l.04.023 4.934 2.74.042.024c.152.083.359.197.517.369.137.148.24.324.303.515.074.223.073.458.072.632v5.508c0 .174.002.41-.072.632a1.416 1.416 0 0 1-.303.515c-.158.172-.364.286-.517.37l-.042.023-4.934 2.74-.04.023c-.144.08-.338.19-.557.235a1.414 1.414 0 0 1-.57 0 1.966 1.966 0 0 1-.557-.235l-.04-.023-4.934-2.74-.042-.024c-.152-.083-.358-.197-.517-.369a1.417 1.417 0 0 1-.303-.515c-.074-.223-.073-.458-.072-.632V5.246c0-.174-.002-.41.072-.632.063-.191.166-.367.303-.515.159-.172.365-.286.517-.37a.416.416 0 0 0 .042-.023l2.44-1.355a.766.766 0 0 1 .022-.012L7.118.966l.04-.023c.144-.08.338-.19.557-.235ZM5 3.858l-1.456.809L8 7.142l1.456-.809L5 3.858Zm6 1.617L6.544 3l1.302-.723.118-.065.036-.02a2.843 2.843 0 0 1 .154.085l4.302 2.39L11 5.475Zm.353 1.52a.812.812 0 0 0 .024-.013l1.873-1.04v4.764a14.345 14.345 0 0 1-.001.185l-.037.022-.125.07-4.337 2.409v-4.95l2.603-1.447ZM7.25 8.441l-4.5-2.5v4.765a12.812 12.812 0 0 0 .001.185l.037.022.125.07 4.337 2.409v-4.95Z",
  "clip-rule": "evenodd"
}, null, -1), a = [
  o
];
function n(r, d) {
  return e(), l("svg", t, [...a]);
}
const v = { render: n };
export {
  v as default,
  n as render
};
